import React from 'react';
import { useState, useEffect } from 'react';
import { get } from "jquery";
import Utils from '../../helpers/utils';

const WLT0101_Master = (props) => {
    const [ninushi, setNinushiList] = useState([]);

    useEffect(() => {
        sessionStorage.clear();
        get({ url: props.getNinushiDtlUrl }, json => {
            let ninushi = JSON.parse(json);
            setNinushiList(ninushi);
        });
    }, []);

    function renderLogo() {
        if (!Utils.isNullOrEmpty(ninushi.LogoFileName)) {
            document.getElementById('placeholder').src = ninushi.LogoFileName;
        }
    }

    return (
        <div>
            {renderLogo()}
        </div>
    );
}

export default WLT0101_Master;


// WEBPACK FOOTER //
// ./view/WLT0101/WLT0101-master.jsx